import { buildUrl, getObjProp } from '@ce-cfbdigital/cgl-cfb-fe-foundation';

import appConfig from '../../../app.config';
import serviceConfig from '../../../services.config';

const runtimeAppConfig = window.__APP_CONFIG__ || {};
const config = { ...appConfig, ...runtimeAppConfig };

const getAppConfig = (key = '') => (key === '' ? null : getObjProp(key, config));

const getServiceConfig = (key = '') => (key === '' ? null : getObjProp(key, serviceConfig));

const getService = (name, params = {}) => {
  const apiConfig = getServiceConfig(name);
  return buildUrl(apiConfig, params);
};

const globalConfig = {
  debounceTime: 500
};

export { getAppConfig, getService, getServiceConfig, globalConfig };
